import React, { useMemo } from 'react';
import { BasicInfoCollapse } from '../../../../../../../components';

export const NetworkAdapters = ({ record }) => {
    const networkInfo = useMemo(
        () => [
            { label: 'IP', value: record?.ip_addresses[0] || 'N/A', copyable: true },
            { label: 'MAC', value: 'N/A' },
            { label: 'Netmask', value: 'N/A' },
            { label: 'Type', value: 'N/A' },
        ],
        [record],
    );

    return <BasicInfoCollapse title="Network Adapters" infoItems={networkInfo} greyHeader={true} />;
};
